<template>
    <div class="card-group">
        <app-sensors v-for="sensor in sensors" :sensor="sensor" :key="sensor.name"></app-sensors>
    </div>
</template>

<script>
import Sensor from "./Sensor.vue";
import axios from "axios";

export default {
    data() {
        return {
            sensors: [],
            numberOfContacts: 0,
        };
    },

    components: {
        appSensors: Sensor,
    },

    computed: {},
    mounted() {
        this.getSensors2();
    },

    methods: {
        getSensors() {
            const app = this;
            return axios
                .get("/master/sensor_readings")
                .then((res) => {
                    for (var item in res.data) {
                        var sensor = { id: item, reading: res.data[item] };
                        app.sensors.push(sensor);
                    }

                    //app.sensors = Object.entries(res.data)
                    console.log(res.data);
                    console.log("Sensors :" + app.sensors);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getSensors2() {
            const app = this;
            return axios
                .get("/master/sensor_list")
                .then((res) => {
                    app.sensors = res.data;

                    //app.sensors = Object.entries(res.data)
                    console.log(res.data);
                    console.log("Sensors :" + app.sensors);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>